import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqCtaSection() {
  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-600 uppercase mb-3">
              <span className="w-6 h-px bg-primary-500 inline-block" />
              常见问题
            </p>
            <h2 className="font-heading text-2xl md:text-4xl tracking-wide text-foreground-950">
              投票评选，你可能想知道
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于入围规则、打分方式与排名刷新的说明都在这里。没找到答案？欢迎来信，我们会补充到问答列表中。
            </p>
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-md border border-foreground-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
            >
              查看全部问题
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={faqs.slice(0, 5)} />
          </div>
        </div>

        <div className="mx-auto max-w-6xl mt-16">
          <div className="relative rounded-lg overflow-hidden bg-secondary-900">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20spotlight%20beam%20over%20an%20empty%20stage%20with%20scattered%20glowing%20score%20cards%2C%20deep%20green%20and%20gold%20abstract%20shapes%2C%20warm%20red%20accents%2C%20editorial%20poster%20aesthetic%2C%20not%20photorealistic&width=1400&height=520&seq=baoliao-cta-01&orientation=landscape"
              alt="爆料大赛投票专区舞台光束与打分卡片背景"
              title="参与爆料大赛投票评选"
              className="w-full h-[300px] md:h-[340px] object-cover object-center opacity-40"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
              <h2 className="font-heading text-3xl md:text-5xl tracking-wide text-background-50">
                你的这一票，可能改变最终排名
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-100 max-w-xl">
                入围名单已经公布，群众打分还在持续更新。现在进入评选专区，为你认可的作品投上一票。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/finalists"
                  className="px-7 py-3.5 rounded-md bg-accent-500 text-accent-950 font-bold text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  立即参与投票
                </Link>
                <Link
                  to="/ranking"
                  className="px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
                >
                  围观排名走势
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}